// ─── INDICADOR DE SCROLL EN LA DESCRIPCIÓN DE LA CARD ─────────
// La descripción del frente tiene alto fijo con scroll y barra oculta. Este
// módulo muestra una flechita ↓ (.product-scroll-hint, hermana de .product-desc)
// SOLO cuando hay más texto para desplazar y aún no se llega al final; así el
// usuario sabe que puede deslizar, sin barra que tape el texto ni difuminados.
(() => {
  "use strict";

  const descs = document.querySelectorAll(".product-desc");
  if (!descs.length) return;

  const EPS = 4; // tolerancia en px (subpíxeles / redondeos)

  const update = (desc) => {
    const hint = desc.nextElementSibling;
    if (!hint || !hint.classList.contains("product-scroll-hint")) return;
    const restante = desc.scrollHeight - desc.clientHeight; // px ocultos abajo
    const hayMas = restante > EPS && desc.scrollTop < restante - EPS;
    hint.classList.toggle("is-visible", hayMas);
  };

  descs.forEach((desc) => {
    update(desc);
    desc.addEventListener("scroll", () => update(desc), { passive: true });
  });

  // Recalcula cuando una card cambia de tamaño (incluye pasar de oculta a
  // visible al filtrar por categoría, donde el alto pasa de 0 a real).
  if ("ResizeObserver" in window) {
    const ro = new ResizeObserver((entradas) => {
      entradas.forEach((e) => update(e.target));
    });
    descs.forEach((desc) => ro.observe(desc));
  }

  window.addEventListener("resize", () => descs.forEach(update), { passive: true });
})();
